<template>
  <div v-if="assignmentCorrectionData" id="correction" class="border border-solid d-theme-border-grey-light rounded-lg relative overflow-hidden vs-con-loading__container">
    <vs-sidebar class="items-no-padding students-sidebar"
                parent="#correction"
                :click-not-close="clickNotClose"
                :hidden-background="clickNotClose"
                v-model="isSidebarActive">
          <assignment-correction-students :students="assignmentCorrectionData.students"
                                          :assignment-mark="assignmentCorrectionData.mark"
                                          :selected-student="selectedStudent"
                                          @closeSidebar="toggleSidebar"
                                          @selected="selected" />
    </vs-sidebar>

    <div :class="{'sidebar-spacer--wide': clickNotClose}" class="no-scroll-content bg-white border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

      <div class="flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">
        <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleSidebar(true)"/>
        <h4 class="my-7 mx-5">{{assignmentCorrectionData.title}}</h4>
      </div>

      <VuePerfectScrollbar class="scroll-content-area" :settings="{ maxScrollbarLength: 60, wheelSpeed: 0.50 }" :key="$vs.rtl">
        <div class="vx-row lg:m-4 m-1">
          <div class="vx-col w-full md:w-1/2 p-4 mx-auto mb-base">
            <div class="w-full mb-base">
              <p class="font-semibold">الوصف</p>
              <text-editor-viewer :data="assignmentCorrectionData.body" class="mb-base p-2" />
              <div v-if="assignmentCorrectionData.file.name" class="flex items-center mb-base p-2">
                <p class="font-semibold">ملف الواجب</p>
                <file class="ml-4"
                      :name="assignmentCorrectionData.file.name"
                      :size="assignmentCorrectionData.file.size"
                      :path="assignmentCorrectionData.file.path" />
              </div>
              <div class="flex justify-between items-center">
                <p>وقت انتهاء الواجب</p>
                <p class="text-xl font-semibold">{{assignmentCorrectionData.deadline | date}}</p>
              </div>
              <vs-divider />
              <div class="flex justify-between items-center">
                <p>الدرجة</p>
                <p class="text-xl font-semibold">{{assignmentCorrectionData.mark}}</p>
              </div>
              <vs-divider />
              <div class="flex justify-between items-center">
                <p>مجموعات المادة</p>
                <p class="text-xl font-semibold">({{assignmentCorrectionData.course_groups.join(', ')}})</p>
              </div>
            </div>
            <vs-button v-if="!assignmentCorrectionData.is_confirmed" @click="confirm" class="m-auto w-full">رصد درجات الواجب</vs-button>
            <vs-alert v-else class="m-auto w-full" type="info" active="true" icon="icon-info" icon-pack="feather">تم رصد الدرجات، يستطيع الطلبة رؤية نتيجة الواجب</vs-alert>
          </div>
          <div class="vx-col w-full md:w-1/2 mb-base">
            <vx-card :title="`إجمالي الطلبة ${statistics.total}`" no-shadow card-border>

              <vue-apex-charts
                type=radialBar
                height=240
                :options="chartOptions"
                :series="statistics.series" />

              <div
                v-if="statistics"
                class="flex justify-between text-center mt-4"
                slot="no-body-bottom">

                <div class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                  <p class="mt-4">اكتمل التصحيح</p>
                  <p class="mb-4 text-3xl font-semibold">{{ statistics.corrected }}</p>
                </div>
                <div class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                  <p class="mt-4">أنجز</p>
                  <p class="mb-4 text-3xl font-semibold">{{ statistics.submitted }}</p>
                </div>
                <div class="w-1/3 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                  <p class="mt-4">لم ينجز</p>
                  <p class="mb-4 text-3xl font-semibold">{{ statistics.notSubmitted }}</p>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </VuePerfectScrollbar>
    </div>

    <assignment-correction-view
      v-if="selectedStudent"
      :student="selectedStudent"
      :assignment-mark="assignmentCorrectionData.mark"
      :is-sidebar-active="isViewActive"
      @correct="reCalcAssignmentCorrection"
      @closeSidebar="closeViewSidebar"/>
  </div>
</template>

<script>
    import assignmentsAPI from "@/api/assignmentsAPI";
    import AssignmentCorrectionStudents from '@/views/course/assignments/correction/AssignmentCorrectionStudents'
    import AssignmentCorrectionView from '@/views/course/assignments/correction/AssignmentCorrectionView'

    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import VueApexCharts from 'vue-apexcharts'
    import charts from '@/assets/utils/charts'
    import TextEditorViewer from '@/views/components/TextEditorViewer'

    export default {
        name: "AssignmentCorrection",
        components: {
          TextEditorViewer,
            AssignmentCorrectionView,
            AssignmentCorrectionStudents,
            VuePerfectScrollbar,
            VueApexCharts
        },
        data() {
            return {
                assignment_id: this.$route.params.assignment_id,
                course_id: this.$route.params.course_id,
                courseGroups: [],
                selectedGroup: 0,
                searchQuery: '',
                clickNotClose: true,
                isSidebarActive: true,
                isViewActive: false,
                studentsCourse: [],
                selectedStudent: null,
                assignmentCorrectionData: null,
                statistics : {corrected: 0, submitted: 0, notSubmitted: 0, total: 0, series: [0]},
                chartOptions: charts.assignChartOptions
            }
        },
        watch: {
            windowWidth() {
                this.setSidebarWidth()
            },
        },
        computed: {
          studentsWithGroups(){
              return this.assignmentCorrectionData.map(students => {
                  return students.filter(student => {
                      return student.full_name.indexOf(this.searchQuery) !== -1
                  })
              })
          },
          windowWidth() {
              return this.$store.state.windowWidth
          },
        },
        methods: {
          confirm(){
              const message = 'عند رصد درجات الواجب يمكن للطلبة عرض درجاتهم التي تم تحديدها سابقاً.' +
                  'يمكنك تعديل اي درجة لاحقاً\n'
              this.$confirmAlert(null, message, () => {
                  this.assignmentCorrectionData.is_confirmed = true
                  assignmentsAPI.confirm(this.assignment_id)
                      .then(response => this.$notifySuccess(response.successMessage))
              }, 'primary')
          },
          selected(student){
              this.selectedStudent = student
              this.toggleSidebar()
              this.isViewActive = true
          },
          reCalcAssignmentCorrection() {
              this.statistics.corrected = this.assignmentCorrectionData.students
                    .filter(student => student.answer && student.answer.mark !== null).length
              this.statistics.series = [this.statistics.submitted !== 0 ?
                      Math.round(this.statistics.corrected * 100 / this.statistics.submitted) : 0]
          },
          calcAssignmentCorrectionData() {
              this.statistics.total = this.assignmentCorrectionData.students.length
              this.statistics.submitted = this.assignmentCorrectionData.students
                  .filter(student => student.answer).length
              this.statistics.corrected = this.assignmentCorrectionData.students
                  .filter(student => student.answer && student.answer.mark !== null).length
              this.statistics.notSubmitted = this.statistics.total - this.statistics.submitted
              this.statistics.series = [this.statistics.submitted !== 0 ?
                  Math.round(this.statistics.corrected * 100 / this.statistics.submitted) : 0]
          },
          setSidebarWidth() {
              if (this.windowWidth < 992) {
                  this.isSidebarActive = this.clickNotClose = false
              } else {
                  this.isSidebarActive = this.clickNotClose = true
              }
          },
          closeViewSidebar() {
              this.selectedStudent = null
              this.isViewActive = false
          },
          toggleSidebar(value = false) {
              if (!value && this.clickNotClose) return
              this.isSidebarActive = value
          },
        },
        beforeRouteEnter(to, from, next) {
            assignmentsAPI.getAssignmentCorrection(to.params.assignment_id).then(({data}) => {
                next(async (vm) => {

                    await vm.$store.dispatch('studentsCourse/loadStudents', to.params.course_id)
                        .then(students => vm.studentsCourse = students)

                    vm.assignmentCorrectionData = data
                    vm.courseGroups = data.course_groups

                    const allStudents = []
                    Object.keys(vm.studentsCourse).forEach(group => {
                        vm.studentsCourse[group].forEach(student => {
                            const studentAnswer = vm.assignmentCorrectionData.students.find(sa => sa.id === student.id)
                            allStudents.push(Object.assign({}, student, studentAnswer, {course_group: group}))
                        })
                    })
                    vm.assignmentCorrectionData.students = allStudents
                    vm.calcAssignmentCorrectionData()
                })
            })
        },
        created() {
            this.setSidebarWidth()
        }
    }
</script>

<style lang="scss">
  @import "@/assets/scss/correction.scss";
</style>
